.root {
  position: relative;
  display: inline-flex;
}
.menu {
  position: fixed;
  z-index: var(--z-popover);
  max-width: calc(100vw - 16px);
  padding: 6px;
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
}
.header {
  padding: 8px 10px 10px;
  border-block-end: 1px solid var(--color-border);
  margin-block-end: 6px;
}
.item {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 10px;
  border: 0;
  border-radius: var(--radius-sm);
  background: transparent;
  color: var(--color-text);
  font-size: var(--text-sm);
  font-weight: 500;
  text-align: start;
  cursor: pointer;
}
.item:hover:not(:disabled),
.item:focus-visible {
  background: var(--color-neutral-soft);
}
.item:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.danger {
  color: var(--color-danger);
}
.sep {
  border: 0;
  border-block-start: 1px solid var(--color-border);
  margin: 6px 0;
}
